import collectionPoster from '@/assets/images/winter-solace-collection.png';

export const order = 5;

export default {
  collection_name: 'Winter Solace Collection',
  collection_desc:
    '\nInspired by the quiet beauty and serenity of winter, the Winter Solace Collection features clean, contemporary tones and a calm, sophisticated aesthetic.\n\nCrafted from Premium White Oak and guided by Sakura Floors\' Japanese-inspired craftsmanship, this collection emphasizes simplicity, balance, and natural elegance. Its carefully curated color palette complements both modern and transitional interiors while showcasing the authentic beauty of real hardwood.\n\nDesigned for those who seek a timeless foundation, the Winter Solace Collection creates bright, tranquil spaces that feel effortlessly refined. Blending understated luxury with everyday livability, it brings warmth, clarity, and a sense of calm to the home for years to come.\n',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Monet',
      sku: 'WS52',
      product_desc:
        'Quiet Serenity. Sophisticated, Luminous Depth. Inspired by the soft, pristine light and peaceful stillness of winter landscapes, Monet brings a calm, fluid elegance to high-end interiors. This premium collection features a beautifully nuanced neutral palette that expertly bridges warm and cool tones, making it an incredibly versatile, sophisticated foundation for modern minimalist, high-end contemporary, or luxury organic spaces.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet%20Video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Monet/Monet01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Monet'],
        ['Grade', 'Prime'],
        ['Wear Layer', '6mm'],
        ['Width', '7.5"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 73" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Van Gogh',
      sku: 'WS53',
      product_desc:
        'Masterful Artistry. Dramatic, Expressive Serenity. Inspired by the swirling, powerful movement and rich emotional depth of legendary artistic masterpieces, Van Gogh brings a bold yet deeply serene presence to high-end interiors. Part of the Winter Solace Collection, this style captures a striking balance of shifting, sophisticated tones that create a stunning, fluid canvas across large architectural spaces.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%2001.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%2002.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%2003.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%2004.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%20Video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Van%20Gogh/Van%20Gogh%2001.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Van Gogh'],
        ['Grade', 'Prime'],
        ['Wear Layer', '5.5mm'],
        ['Width', '7.0"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 70" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Pissarro',
      sku: 'WS54',
      product_desc:
        'Subtle Textures. Gentle, Light-Filled Elegance. Inspired by the meticulous, light-dappled techniques of classic impressionist landscapes, Pissarro brings a soft, inviting warmth and architectural clarity to luxury interiors. Part of the Winter Solace Collection, this style features a beautifully balanced neutral palette designed to maximize natural light, creating a serene, open atmosphere across any expansive floor plan.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Pissarro/Pissarro01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Pissarro'],
        ['Grade', 'Prime'],
        ['Wear Layer', '5.5mm'],
        ['Width', '7.0"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 78" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Renoir',
      sku: 'WS31',
      product_desc:
        'Vibrant Artistry. Rich, Living Textures. Inspired by the warm, light-filled, and deeply textured brushwork of master impressionist art, Renoir brings an undeniably authentic and soulful presence to luxury interiors. Part of our Winter Solace Collection, this style is designed for spaces that embrace natural elegance, offering a beautiful palette that brings warmth, movement, and a lived-in luxury to any room.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir%20interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Renoir/Renoir01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Renoir'],
        ['Grade', 'Character'],
        ['Wear Layer', '6mm'],
        ['Width', '7.0"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 72" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Degas',
      sku: 'WS57',
      product_desc:
        'Poetic Movement. Soft, Expressive Balance. Inspired by the fluid, graceful lines and atmospheric depth of classic impressionist masterworks, Degas brings a sense of refined artistry and organic life to luxury spaces. Part of our Winter Solace Collection, this style is designed to catch the light beautifully, offering a sophisticated neutral palette that introduces soft warmth and effortless flow into any expansive interior.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Degas/Degas%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Degas/Degas01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Degas/Degas02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Degas/Degas03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Degas/Degas04.jpg',
        },
      ],
      product_galleries_video: [],
      product_attributes: [
        ['Color', 'Degas'],
        ['Grade', 'Character'],
        ['Wear Layer', '5.5mm'],
        ['Width', '7.0"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 70" with 70% full length'],
        ['Species', 'Walnut'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Misty Harbor 9.5',
      sku: '63201',
      product_desc:
        'Poetic Movement. Soft, Expressive Balance. Inspired by the fluid, graceful lines and atmospheric depth of classic impressionist masterworks, Degas brings a sense of refined artistry and organic life to luxury spaces. Part of our Winter Solace Collection, this style is designed to catch the light beautifully, offering a sophisticated neutral palette that introduces soft warmth and effortless flow into any expansive interior.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5_1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5_2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5_3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5_4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Misty%20Harbor%209.5/Misty%20Harbor%209.5_1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Misty Harbor 9.5'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4.0mm'],
        ['Width', '9.5"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Walnut'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Buttered Wheat 9.5',
      sku: '6408',
      product_desc:
        'Poetic Movement. Soft, Expressive Balance. Inspired by the fluid, graceful lines and atmospheric depth of classic impressionist masterworks, Degas brings a sense of refined artistry and organic life to luxury spaces. Part of our Winter Solace Collection, this style is designed to catch the light beautifully, offering a sophisticated neutral palette that introduces soft warmth and effortless flow into any expansive interior.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%209.5%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%209.5_01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%209.5_02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%209.5_03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%209.5_04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%20Video%209.5_01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Winter%20Solace%20Collection/Buttered%20Wheat%209.5/Buttered%20Wheat%209.5_01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Buttered Wheat 9.5'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4.0mm'],
        ['Width', '9.5"'],
        ['Thickness', '3/4"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Walnut'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
